<template>
  <div class="seg-item">
    <div class="seg-col seg-action-col" v-if="selectAble">
      <a-checkbox
        :disabled="segCheckDisable"
        :checked="seg.checked"
        @change="onChange($event, seg)"></a-checkbox>
    </div>
    <div class="seg-col">
      <div class="seg-info">
        <segment-Info
          :seg="seg"
          :order="order"
          v-bind="$attrs"
        ></segment-Info>
        <extend-info
          v-if="seg.ancillaries.length"
          :seg="seg"
          :order="order"
          v-bind="$attrs"
          v-on="$listeners"
        ></extend-info>
      </div>
    </div>
  </div>
</template>

<script>
import SegmentInfo from './SegmentInfo'
import ExtendInfo from './ExtendInfo'

export default {
  name: 'SegmentBox',
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    },
    passenger: {
      type: Object,
      default: function () {
        return {}
      }
    },
    seg: {
      type: Object,
      default: function () {
        return {}
      }
    },
    selectAble: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    segCheckDisable: function () {
      if (this.seg.ticketStatus) {
        return this.seg.ticketStatus !== 'OPEN_FOR_USE'
      } else {
        return ['RR', 'HK', 'HL'].indexOf(this.seg.status) < 0
      }
    }
  },
  methods: {
    onChange: function (e, seg) {
      this.$emit('seg-change', e, seg)
    }
  },
  components: {
    SegmentInfo,
    ExtendInfo
  }
}
</script>
